import Entity from '../entity'

export default class Segment extends Entity<number>{
    code: number;
    name: string;
    min_year: number;
    max_year: number;
}


